export function login(token){
    return {
        type : "LOGIN",
        token
    }
}

export function setUsername(username){
    return {
        type : "SET_USERNAME",
        username
    }
}

export function setPassword(password){
    return {
        type : "SET_PASSWORD",
        password
    }
}

export function logout(){
    return {
        type : "LOGOUT"
    }
}
